import styled from 'styled-components'

export const App = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  a {
    text-decoration: none;
  }
`
